/*
 *默认执行的扩展工具
 */

//字符串替换
String.prototype.render = function(params) {
    var output = this.valueOf();
    for (var name in params) {
        var reg = new RegExp('\\{\\{' + name + '\\}\\}', 'g');
        output = output.replace(reg, params[name]);
    }
    return output;
};
define("util/extend", function(){});

